/**
 * Props for {@link SupportTicketTitle}.
 */
interface SupportTicketTitleProps {
  title: string;
}

/**
 * Displays the selected support ticket title.
 *
 * @param props - Ticket title text.
 * @returns Bold ticket heading.
 */
const SupportTicketTitle = ({ title }: SupportTicketTitleProps) => {
  return (
    <h2 className="support-tickets-content-title text-base font-bold leading-6 text-[#0F0F0F]">
      {title}
    </h2>
  );
};

export default SupportTicketTitle;
